import {
    USER_DETAILS_RECEIVE,
    USER_DETAILS_ERROR
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    user: {},
    errors: {}
};

export const user = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case USER_DETAILS_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload
            };
        case USER_DETAILS_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        default:
            return state;
    }
};
